import { getCMSHost } from '@utils/api-helper/host';
import fetch, { simpleFetch as fetcher } from '@api/fetchers';

const CMSHost = getCMSHost();

export const fetchEventData = (id) => fetcher(`${CMSHost}api/utsav/${id}`);

export const fetchIsRegisteredUser = (accessToken) =>
  fetch('v1/common/lottery/', {
    requestType: 'GET',
    tokens: { accessToken }
  });

export const submitLotteryForm = ({
  schoolName,
  className,
  selectedGoal,
  selectedCity,
  accessToken
}) => {
  const formData = new FormData();
  formData.append('city_name', selectedCity);
  formData.append('target_exam', selectedGoal);
  formData.append('school_name', schoolName);
  formData.append('class', className);

  return fetch('v1/common/lottery/', {
    requestType: 'POST',
    body: formData,
    isFormData: true,
    tokens: { accessToken }
  });
};
